import styled from 'styled-components';
import { Collapse, Card, Row } from 'antd';
const isMobile = window.innerWidth < 768;

export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  padding: 5px 5px;
  margin: 32px 24px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(231, 250, 255, 1);
  
  svg {
    font-size: 24px;
    color: rgba(0, 141, 210, 1); 
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 10px;
  font-size: 18px;
  line-height: 24px;
  background-color: transparent;
`;

export const SearchButton = styled.button`
  background-color: #00bfff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background-color: #00a3e0;
  }
`;

export const StyledCard = styled(Card)`
  padding: 32 !important;
  .ant-card-body {
    padding: 0 !important; 
  }

  .ant-table-wrapper .ant-table-thead >tr>th {
    background: rgba(244, 245, 247, 1) !important;
  }

   .ant-table-container table>thead>tr:first-child >* {
   border-radius: 0 !important;
   height: 72px;
   border: 1px solid rgba(229, 233, 242, 1);
   }

   .ant-table-cell {
   height: 72px;
   }

   .ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
   display: none;
}
`;

export const ButtonContainer = styled.div`
  background-color: white;
  width: ${isMobile ? '38px' : '48px'};
  height: ${isMobile ? '38px' : '48px'};
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 189, 244, 1);
    & svg {
      color: #fff;
    }
  }
`;

export const SurveyRow = styled(Row)<{ isSelected: boolean }>`
  border: ${({ isSelected }) =>
    isSelected
      ? '1px solid rgba(255, 243, 232, 1)'
      : '1px solid rgba(229, 233, 242, 1)'};
  background: ${({ isSelected }) =>
    isSelected ? 'rgba(255, 243, 232, 1)' : '#ffffff'};
  padding: 16px 18px;
  border-radius: 8px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${({ isSelected }) =>
      isSelected ? 'rgba(245, 235, 215, 1)' : '#f5f5f5'};
  }
`;